<template>
  <b-tooltip
    label="Download This Page of Results"
    v-if="results.rows"
  >
    <a
      v-if="csvData"
      download="export.csv"
      v-bind:href="csvData"
    >
      <b-icon
        pack="fas"
        icon="download"
      />
    </a>
  </b-tooltip>
</template>

<script>
  import _ from 'lodash';
  import papa from 'papaparse';

  export default {
    data() {
      return {}
    },
    components: {},
    props: {
      results: Object
    },
    methods: {},
    computed: {
      csvData: function() {
        if (this.results.rows.length === 0 || !this.$parent.$refs || !this.$parent.$refs.resultsTable) {
          return;
        }
        let cols = this.$parent.$refs.resultsTable.newColumns.filter((itm) => { return itm.label }).map((itm) => {
          return {
            'label': itm.label,
            'field': itm.field,
          }
        });
        let rows = this.results.rows.map((row) => {
          return cols.reduce((acc, col) => {
            acc[col.label] = _.get(row, col.field);
            return acc;
          }, {});
        });
        let csvFile = papa.unparse(rows);
        csvFile = `"
          Copyright Stake PBC. All rights reserved. You may not use the information contained herein as the basis for any derivative product 
          (including, without limitation, constructing, modifying, or maintaining any index or passively managed investment products) 
          without the express written consent of Stake PBC.
          The information, data, analyses and opinions contained herein
          (1) include the proprietary information of Stake PBC, or third party content providers
          (2) may not be copied or redistributed, (3) do not constitute investment advice offered by Stake PBC
          (4) are provided solely for informational purposes
          (5) are not warranted to be timely, complete or accurate. Except to the extent otherwise specifically
              required by law, neither Stake PBC, nor its affiliates nor their third party content providers shall
              be responsible for any trading decisions, damages or other losses resulting from, or related to, this
              information, data, analyses, opinions or their use.
        "\n\n${csvFile}`;
        return `data:text/csv;charset=utf-8,${encodeURIComponent(csvFile)}`;
      }
    },
    created: function() {},
  }
</script>

<style lang="scss">

</style>
